import React, { Component, PropTypes } from 'react';
import { Button, Modal, Input, Form, Select, InputNumber } from 'antd';
import { FacebookLogin } from 'components';
import cn from 'classnames';
import Utils from 'utils/utils';
import { formItemLayout } from 'constants/layout';
import _ from 'lodash';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { updateDiscount } from 'data/teacher';
import { connect } from 'react-redux';

const Option = Select.Option;

const FormItem = Form.Item;
const { TextArea } = Input;
const customStyles = {
  overlay: {
    zIndex: 2000,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

class DiscountTeacherModal extends Component {
  static propTypes = {
    // form: PropTypes.Any,
    // teacher: PropTypes.Object,
    // reload: PropTypes.func,
    // handleCancel: PropTypes.func,
  };
  static defaultProps = {
    teacher: {},
  };
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isShow: true,
    };
    // this.login = this.login.bind(this);
  }

  handleSubmit(e) {
    // return;
    e.preventDefault();
    const props = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        updateDiscount(this.props.teacher._id, {
          ...values,
        }).then(async () => {
          await props.reload();
          props.handleCancel();
        });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const teacher = this.props.teacher;
    let isRenderDiscount = false;
    const feeDiscountExpired = moment(teacher.feeDiscountExpired).format('D MMM YYYY');
    const feeDiscountRemaining = teacher.feeDiscountRemaining;
    const feeDiscount = teacher.feeDiscount;
    if (feeDiscountRemaining > 0 && feeDiscount > 0) {
      isRenderDiscount = true;
    }
    return (
      <Modal
        title={'Update Discount'}
        visible={this.props.isOpen}
        onCancel={this.props.handleCancel}
        footer={[
          <Button key="back" size="large" onClick={this.props.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmit}>
            Save
          </Button>,
        ]}
      >
        <div className={'padding-bottom-30'}>
          <div>
            <span className="bold">Teacher: </span> {`${_.get(teacher, 'name.first')} ${_.get(teacher, 'name.last')}`}
          </div>
          {isRenderDiscount ? (
            <div>
              Fee Discount {feeDiscount}% | {feeDiscountRemaining} Schedules remained | Expire {feeDiscountExpired}
            </div>
          ) : (
            <div>{"Don't have any discount yet!"}</div>
          )}
        </div>

        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="%Com Disc" hasFeedback>
            {getFieldDecorator('feeDiscount', {
              rules: [
                {
                  required: true,
                  type: 'number',
                  max: 100,
                  min: 0,
                  message: 'Please input Discount',
                },
              ],
            })(<InputNumber />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Sche. Count" hasFeedback>
            {getFieldDecorator('feeDiscountRemaining', {
              rules: [
                {
                  required: true,
                  type: 'number',
                  max: 100000,
                  min: 0,
                  message: 'Please input Sche. Count',
                },
              ],
            })(<InputNumber />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Length" hasFeedback>
            {getFieldDecorator('months', {
              rules: [
                {
                  required: true,
                  message: 'Please input Page',
                },
              ],
            })(
              <Select>
                <Option value="1">1 month</Option>
                <Option value="2">2 months</Option>
                <Option value="3">3 months</Option>
                <Option value="4">4 months</Option>
                <Option value="5">5 months</Option>
                <Option value="6">6 months</Option>
              </Select>,
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(DiscountTeacherModal);
